import KeyPointIndicatorFormView from "./KeyPointIndicatorFormView";

import "./KeyPointIndicatorFormView.scss";

export { KeyPointIndicatorFormView };
